import * as Sentry from '@sentry/react';

export const captureException = (
  error: unknown,
  options: {
    level?: Sentry.SeverityLevel;
    //Attached to the event rather than written into the message, so events of
    //the same kind still group into one issue
    extra?: Record<string, unknown>;
  } = {},
) => {
  Sentry.withScope((scope) => {
    if (options.level) {
      scope.setLevel(options.level);
    }
    if (options.extra) {
      scope.setExtras(options.extra);
    }
    Sentry.captureException(error);
  });
};
